import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getCurrentBooking } from 'redux/selectors/current_booking';

export function BookingSteps() {
  const bookingStep = useSelector((state) => state.booking.step);
  const booking = useSelector(getCurrentBooking);
  const hasCartData = booking.reservations_attributes?.length;

  return (
    <div
      className={`booking-steps ${
        hasCartData ? '' : 'booking-steps--no-booking'
      } d-none d-lg-block`}
      data-testid="booking-steps"
    >
      <div className="row">
        <Link
          to="/cart"
          className={`${
            bookingStep === 1 ? 'booking-steps__step--clickable ' : ''
          }booking-steps__step col`}
        >
          <div className="booking-steps__dot">
            <i
              data-testid="review-dot"
              className={
                // eslint-disable-next-line no-nested-ternary
                hasCartData
                  ? bookingStep === 0
                    ? 'fas fa-circle'
                    : 'fas fa-check-circle'
                  : 'far fa-circle'
              }
            />
          </div>
          <span className="booking-steps__name">Review</span>
        </Link>
        <div className="booking-steps__step col">
          <div className="booking-steps__dot">
            <i
              data-testid="checkbox-dot"
              className={
                // eslint-disable-next-line no-nested-ternary
                bookingStep === 1
                  ? 'fas fa-circle'
                  : bookingStep >= 2
                  ? 'fas fa-check-circle'
                  : 'far fa-circle'
              }
            />
          </div>
          <span className="booking-steps__name">Checkout</span>
        </div>
        <div className="booking-steps__step col">
          <div className="booking-steps__dot">
            <i
              data-testid="confirmation-dot"
              className={
                bookingStep >= 2 ? 'fas fa-check-circle' : 'far fa-circle'
              }
            />
          </div>
          <span className="booking-steps__name">Confirmation</span>
        </div>
      </div>
    </div>
  );
}
